const Theme = {
  logo_height: 130,
  logo_image_url: 'bullesdesavon.png',

  body_background_color: '#00a1e4',

  button_color: '#00a1e4',
  button_half_border_color: '#00a1e4',

  text_font: `'Inter', sans-serif`,
  title_font: `'Inter', sans-serif`,
}

export default Theme
